import React, { useEffect, useRef } from 'react';
import { Map, Polyline, Marker, GoogleApiWrapper } from 'google-maps-react';
import { useDecodedPolyline } from '../../hooks/useDecodedPolyline';
import { max } from 'lodash';

const RouteMap = ({ google, route }) => {
  const { path } = useDecodedPolyline(route);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || !path.length) return;

    const bounds = new google.maps.LatLngBounds();

    path.forEach(p => bounds.extend(p));

    mapRef.current.map.fitBounds(bounds);
  }, [path, google]);

  const startPoint = path.length > 0 ? path[0] : null;
  const endPoint   = path.length > 1 ? path[path.length - 1] : null;

  const startIcon = {
    url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
    scaledSize: new google.maps.Size(40, 40),
    anchor: new google.maps.Point(20, 40),
  };

  const endIcon = {
    url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
    scaledSize: new google.maps.Size(40, 40),
    anchor: new google.maps.Point(20, 40),
  };

  return (
    <div style={{ height: '70vh', width: '100%'}}>
        <Map
        google={google}
        ref={mapRef}
        zoom={16}
        style={{ width: '100%', height: '100%', position: 'relative', maxWidth: window.innerWidth <= 768 ? '300px' : '100%' }}
        >
        {path.length > 0 && (
            <Polyline
            path={path}
            strokeColor="#FF6633"
            strokeOpacity={0.9}
            strokeWeight={6}
            />
        )}
        {startPoint && (
            <Marker
            position={startPoint}
            icon={startIcon}
            title="Inicio"
            />
        )}
        {endPoint && (
            <Marker
            position={endPoint}
            icon={endIcon}
            title="Fin"
            />
        )}
        </Map>
    </div>
  );
}; 

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAOyqbslXqz9nQ1JvaWO-ihiQOSsWDi3oE',
})(RouteMap);
